import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	myEmployee: {},
	getStats: {},
	employeeDetail: {},
	memberAbsent:[],
	memberLate:[],
	memberOffDay:[],
	memberLeave:[],
	memberPresent:[]
};

// active account slice
export const myDashboardSlice = createSlice({
	name: 'myDashboard',
	initialState,
	reducers: {
		setMyEmployee: (state, action) => {
			state.myEmployee = action.payload;
		},
		setMyEmployeeEmpty: (state) => {
			state.myEmployee = [];
		},
		setGetStats: (state, action) => {
			state.getStats = action.payload;
		},
		setGetStatsEmpty: (state) => {
			state.getStats = [];
		},
		setEmployeeDetail: (state, action) => {
			state.employeeDetail = action.payload;
		},
		setEmployeeDetailEmpty: (state) => {
			state.employeeDetail = [];
		},

		// ********************

		setMemberAbsent: (state, action) => {
			state.memberAbsent = action.payload;
		},
		setMemberAbsentEmpty: (state) => {
			state.memberAbsent = [];
		},

		setMemberLate: (state, action) => {
			state.memberLate = action.payload;
		},
		setMemberLateEmpty: (state) => {
			state.memberLate = [];
		},

		setMemberOffDay: (state, action) => {
			state.memberOffDay = action.payload;
		},
		setMemberOffDayEmpty: (state) => {
			state.memberOffDay = [];
		},

		setMemberLeave: (state, action) => {
			state.memberLeave = action.payload;
		},
		setMemberLeaveEmpty: (state) => {
			state.memberLeave = [];
		},
		setMemberPresent: (state, action) => {
			state.memberPresent = action.payload;
		},
		setMemberPresentEmpty: (state) => {
			state.memberPresent = [];
		}
	},
});

export const {
	setMyEmployee,
	setMyEmployeeEmpty,
	setGetStats,
	setGetStatsEmpty,
	setEmployeeDetail,
	setEmployeeDetailEmpty,
	setMemberAbsent,
	setMemberAbsentEmpty,
	setMemberLate,
	setMemberLateEmpty,
	setMemberOffDay,
	setMemberOffDayEmpty,
	setMemberLeave,
	setMemberLeaveEmpty,
	setMemberPresent,
	setMemberPresentEmpty
} = myDashboardSlice.actions;

export default myDashboardSlice.reducer;
